<div [class]="gridClass()" aria-hidden="true">
  @for (placeholder of placeholders(); track placeholder) {
    <div [class]="itemClasses()">
      <div class="absolute bottom-3 left-3 h-4 w-24 rounded bg-gray"></div>
    </div>
  }
</div>
